var _g, _g2, _g3, _g4, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 60,
    viewBox: "0 0 118 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4384 24.4934V23.7146L19.4316 21.9458C19.5812 21.8138 19.6868 21.6895 19.7484 21.5729C19.81 21.4563 19.8408 21.3474 19.8408 21.2462C19.8408 21.101 19.8111 20.9723 19.7517 20.8601C19.6923 20.7457 19.6087 20.6566 19.5009 20.5928C19.3931 20.5268 19.2666 20.4938 19.1214 20.4938C18.9696 20.4938 18.8354 20.529 18.7188 20.5994C18.6044 20.6676 18.5153 20.7589 18.4515 20.8733C18.3877 20.9855 18.358 21.1076 18.3624 21.2396H17.4384C17.4384 20.914 17.5099 20.6324 17.6529 20.3948C17.7959 20.1572 17.995 19.9735 18.2502 19.8437C18.5054 19.7139 18.8024 19.649 19.1412 19.649C19.4514 19.649 19.7286 19.7172 19.9728 19.8536C20.2192 19.9878 20.4128 20.1759 20.5536 20.4179C20.6944 20.6599 20.7648 20.9404 20.7648 21.2594C20.7648 21.4948 20.7318 21.6906 20.6658 21.8468C20.5998 22.0008 20.5019 22.1438 20.3721 22.2758C20.2423 22.4056 20.0828 22.553 19.8936 22.718L18.6066 23.8466L18.534 23.6486H20.7648V24.4934H17.4384Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.35 28.9191C21.35 27.7628 19.6794 27.166 19.1156 26.0936L19.0948 26.075L19.0843 26.0936C18.5205 27.166 16.85 27.7628 16.85 28.9191C16.85 29.8889 18.2804 30.2619 18.9799 29.4506C18.9903 29.4133 18.9799 29.7117 18.9277 29.8796C18.7606 30.3738 18.1551 31.1012 17.8627 31.325C18.2699 31.0172 19.9091 31.0172 20.3163 31.325C20.024 31.1012 19.4497 30.4018 19.2514 29.8796C19.2096 29.7304 19.1887 29.5905 19.1783 29.4413C19.8674 30.3178 21.35 29.9075 21.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M29.1499 35.4944C29.1499 33.4131 26.143 32.3389 25.1281 30.4086L25.0905 30.375L25.0717 30.4086C24.0569 32.3389 21.0499 33.4131 21.0499 35.4944C21.0499 37.2401 23.6246 37.9115 24.8838 36.4512C24.9026 36.3841 24.8838 36.9212 24.7898 37.2233C24.4891 38.1129 23.3991 39.4222 22.8729 39.825C23.6058 39.2711 26.5564 39.2711 27.2894 39.825C26.7632 39.4222 25.7295 38.1633 25.3724 37.2233C25.2973 36.9548 25.2597 36.703 25.2409 36.4344C26.4812 38.0122 29.1499 37.2737 29.1499 35.4944Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9983 24.5858C30.7607 24.5858 30.5341 24.5385 30.3185 24.4439C30.1029 24.3471 29.9148 24.2118 29.7542 24.038C29.5958 23.8642 29.4825 23.6596 29.4143 23.4242L30.2855 23.1932C30.3317 23.367 30.4219 23.5023 30.5561 23.5991C30.6925 23.6937 30.8399 23.741 30.9983 23.741C31.1347 23.741 31.259 23.708 31.3712 23.642C31.4856 23.576 31.5758 23.4869 31.6418 23.3747C31.71 23.2625 31.7441 23.1382 31.7441 23.0018C31.7441 22.7972 31.6737 22.6223 31.5329 22.4771C31.3943 22.3297 31.2161 22.256 30.9983 22.256C30.9323 22.256 30.8685 22.2659 30.8069 22.2857C30.7453 22.3033 30.6859 22.3286 30.6287 22.3616L30.2261 21.6554L31.7375 20.4014L31.8035 20.5928H29.5991V19.748H32.5691V20.5928L31.3943 21.728L31.3877 21.4772C31.6605 21.519 31.8904 21.6147 32.0774 21.7643C32.2666 21.9117 32.4096 22.0943 32.5064 22.3121C32.6054 22.5277 32.6549 22.7576 32.6549 23.0018C32.6549 23.301 32.579 23.5705 32.4272 23.8103C32.2754 24.0479 32.0741 24.2371 31.8233 24.3779C31.5725 24.5165 31.2975 24.5858 30.9983 24.5858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.35 28.9191C33.35 27.7628 31.6794 27.166 31.1156 26.0936L31.0948 26.075L31.0843 26.0936C30.5205 27.166 28.85 27.7628 28.85 28.9191C28.85 29.8889 30.2804 30.2619 30.9799 29.4506C30.9903 29.4133 30.9799 29.7117 30.9277 29.8796C30.7606 30.3738 30.1551 31.1012 29.8627 31.325C30.2699 31.0172 31.9091 31.0172 32.3163 31.325C32.024 31.1012 31.4497 30.4018 31.2514 29.8796C31.2096 29.7304 31.1887 29.5905 31.1783 29.4413C31.8674 30.3178 33.35 29.9075 33.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.1499 35.4944C41.1499 33.4131 38.143 32.3389 37.1281 30.4086L37.0905 30.375L37.0717 30.4086C36.0569 32.3389 33.0499 33.4131 33.0499 35.4944C33.0499 37.2401 35.6246 37.9115 36.8838 36.4512C36.9026 36.3841 36.8838 36.9212 36.7898 37.2233C36.4891 38.1129 35.3991 39.4222 34.8729 39.825C35.6058 39.2711 38.5564 39.2711 39.2894 39.825C38.7632 39.4222 37.7295 38.1633 37.3724 37.2233C37.2973 36.9548 37.2597 36.703 37.2409 36.4344C38.4812 38.0122 41.1499 37.2737 41.1499 35.4944Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 11,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4655 18.5V17.7608H41.3997V16.9226L42.8979 13.748H43.9275L42.4293 16.9226H43.4655V15.7346H44.3763V16.9226H44.7987V17.7608H44.3763V18.5H43.4655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.35 22.9191C45.35 21.7628 43.6794 21.166 43.1156 20.0936L43.0948 20.075L43.0843 20.0936C42.5205 21.166 40.85 21.7628 40.85 22.9191C40.85 23.8889 42.2804 24.2619 42.9799 23.4506C42.9903 23.4133 42.9799 23.7117 42.9277 23.8796C42.7606 24.3738 42.1551 25.1012 41.8627 25.325C42.2699 25.0172 43.9091 25.0172 44.3163 25.325C44.024 25.1012 43.4497 24.4018 43.2514 23.8796C43.2096 23.7304 43.1887 23.5905 43.1783 23.4413C43.8674 24.3178 45.35 23.9075 45.35 22.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.1499 29.4944C53.1499 27.4131 50.143 26.3389 49.1281 24.4086L49.0905 24.375L49.0717 24.4086C48.0569 26.3389 45.0499 27.4131 45.0499 29.4944C45.0499 31.2401 47.6246 31.9115 48.8838 30.4512C48.9026 30.3841 48.8838 30.9212 48.7898 31.2233C48.4891 32.1129 47.3991 33.4222 46.8729 33.825C47.6058 33.2711 50.5564 33.2711 51.2894 33.825C50.7632 33.4222 49.7295 32.1633 49.3724 31.2233C49.2973 30.9548 49.2597 30.703 49.2409 30.4344C50.4812 32.0122 53.1499 31.2737 53.1499 29.4944Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 11,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0311 18.599C54.7913 18.599 54.5658 18.5495 54.3546 18.4505C54.1456 18.3515 53.9652 18.214 53.8134 18.038C53.6616 17.862 53.5527 17.6574 53.4867 17.4242L54.3513 17.1932C54.3799 17.3054 54.4305 17.4022 54.5031 17.4836C54.5779 17.565 54.6637 17.6288 54.7605 17.675C54.8595 17.719 54.9607 17.741 55.0641 17.741C55.2005 17.741 55.3248 17.708 55.437 17.642C55.5514 17.576 55.6416 17.4869 55.7076 17.3747C55.7758 17.2625 55.8099 17.1382 55.8099 17.0018C55.8099 16.8654 55.7758 16.7411 55.7076 16.6289C55.6416 16.5167 55.5514 16.4276 55.437 16.3616C55.3248 16.2956 55.2005 16.2626 55.0641 16.2626C54.8969 16.2626 54.7605 16.2912 54.6549 16.3484C54.5493 16.4034 54.4701 16.4562 54.4173 16.5068L53.6583 16.2758L53.8035 13.748H56.3973V14.5862H54.2985L54.6153 14.2892L54.5163 15.9194L54.3645 15.7346C54.4833 15.6378 54.6186 15.5674 54.7704 15.5234C54.9222 15.4794 55.0641 15.4574 55.1961 15.4574C55.4953 15.4574 55.7582 15.5245 55.9848 15.6587C56.2136 15.7907 56.3918 15.9733 56.5194 16.2065C56.6492 16.4375 56.7141 16.7026 56.7141 17.0018C56.7141 17.301 56.636 17.5716 56.4798 17.8136C56.3236 18.0534 56.1179 18.2448 55.8627 18.3878C55.6075 18.5286 55.3303 18.599 55.0311 18.599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.35 22.9191C57.35 21.7628 55.6794 21.166 55.1156 20.0936L55.0948 20.075L55.0843 20.0936C54.5205 21.166 52.85 21.7628 52.85 22.9191C52.85 23.8889 54.2804 24.2619 54.9799 23.4506C54.9903 23.4133 54.9799 23.7117 54.9277 23.8796C54.7606 24.3738 54.1551 25.1012 53.8627 25.325C54.2699 25.0172 55.9091 25.0172 56.3163 25.325C56.024 25.1012 55.4497 24.4018 55.2514 23.8796C55.2096 23.7304 55.1887 23.5905 55.1783 23.4413C55.8674 24.3178 57.35 23.9075 57.35 22.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M65.1499 29.4944C65.1499 27.4131 62.143 26.3389 61.1281 24.4086L61.0905 24.375L61.0717 24.4086C60.0569 26.3389 57.0499 27.4131 57.0499 29.4944C57.0499 31.2401 59.6246 31.9115 60.8838 30.4512C60.9026 30.3841 60.8838 30.9212 60.7898 31.2233C60.4891 32.1129 59.3991 33.4222 58.8729 33.825C59.6058 33.2711 62.5564 33.2711 63.2894 33.825C62.7632 33.4222 61.7295 32.1633 61.3724 31.2233C61.2973 30.9548 61.2597 30.703 61.2409 30.4344C62.4812 32.0122 65.1499 31.2737 65.1499 29.4944Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 11,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1658 18.599C66.8512 18.599 66.5685 18.5253 66.3177 18.3779C66.0691 18.2305 65.8722 18.0259 65.727 17.7641C65.5818 17.5001 65.5092 17.1954 65.5092 16.85V15.4706C65.5092 15.0966 65.5818 14.7743 65.727 14.5037C65.8722 14.2309 66.0768 14.0219 66.3408 13.8767C66.6048 13.7293 66.915 13.6556 67.2714 13.6556C67.5024 13.6556 67.7224 13.6897 67.9314 13.7579C68.1404 13.8261 68.3318 13.9416 68.5056 14.1044L67.8654 14.7446C67.7862 14.6654 67.6949 14.6038 67.5915 14.5598C67.4881 14.5158 67.3814 14.4938 67.2714 14.4938C67.0998 14.4938 66.9502 14.5345 66.8226 14.6159C66.6972 14.6951 66.5993 14.7996 66.5289 14.9294C66.4607 15.057 66.4266 15.1934 66.4266 15.3386V16.0448L66.2748 15.8798C66.4112 15.7412 66.5685 15.6356 66.7467 15.563C66.9271 15.4882 67.113 15.4508 67.3044 15.4508C67.6036 15.4508 67.8665 15.5179 68.0931 15.6521C68.3219 15.7863 68.5001 15.97 68.6277 16.2032C68.7575 16.4364 68.8224 16.7026 68.8224 17.0018C68.8224 17.301 68.7465 17.5716 68.5947 17.8136C68.4429 18.0534 68.2416 18.2448 67.9908 18.3878C67.74 18.5286 67.465 18.599 67.1658 18.599ZM67.1658 17.741C67.3022 17.741 67.4265 17.708 67.5387 17.642C67.6531 17.576 67.7433 17.4869 67.8093 17.3747C67.8775 17.2625 67.9116 17.1382 67.9116 17.0018C67.9116 16.8654 67.8786 16.7411 67.8126 16.6289C67.7466 16.5145 67.6575 16.4243 67.5453 16.3583C67.4331 16.2901 67.3088 16.256 67.1724 16.256C67.036 16.256 66.9106 16.2901 66.7962 16.3583C66.684 16.4243 66.5938 16.5145 66.5256 16.6289C66.4596 16.7411 66.4266 16.8654 66.4266 17.0018C66.4266 17.1338 66.4596 17.2559 66.5256 17.3681C66.5916 17.4803 66.6807 17.5705 66.7929 17.6387C66.9051 17.7069 67.0294 17.741 67.1658 17.741Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.35 22.9191C69.35 21.7628 67.6794 21.166 67.1156 20.0936L67.0948 20.075L67.0843 20.0936C66.5205 21.166 64.85 21.7628 64.85 22.9191C64.85 23.8889 66.2804 24.2619 66.9799 23.4506C66.9903 23.4133 66.9799 23.7117 66.9277 23.8796C66.7606 24.3738 66.1551 25.1012 65.8627 25.325C66.2699 25.0172 67.9091 25.0172 68.3163 25.325C68.024 25.1012 67.4497 24.4018 67.2514 23.8796C67.2096 23.7304 67.1887 23.5905 67.1783 23.4413C67.8674 24.3178 69.35 23.9075 69.35 22.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M77.1499 29.4944C77.1499 27.4131 74.143 26.3389 73.1281 24.4086L73.0905 24.375L73.0717 24.4086C72.0569 26.3389 69.0499 27.4131 69.0499 29.4944C69.0499 31.2401 71.6246 31.9115 72.8838 30.4512C72.9026 30.3841 72.8838 30.9212 72.7898 31.2233C72.4891 32.1129 71.3991 33.4222 70.8729 33.825C71.6058 33.2711 74.5564 33.2711 75.2894 33.825C74.7632 33.4222 73.7295 32.1633 73.3724 31.2233C73.2973 30.9548 73.2597 30.703 73.2409 30.4344C74.4812 32.0122 77.1499 31.2737 77.1499 29.4944Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 11,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0046 18.5L79.6018 14.5928H77.569V13.748H80.5654V14.5928L78.9748 18.5H78.0046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.35 22.9191C81.35 21.7628 79.6794 21.166 79.1156 20.0936L79.0948 20.075L79.0843 20.0936C78.5205 21.166 76.85 21.7628 76.85 22.9191C76.85 23.8889 78.2804 24.2619 78.9799 23.4506C78.9903 23.4133 78.9799 23.7117 78.9277 23.8796C78.7606 24.3738 78.1551 25.1012 77.8627 25.325C78.2699 25.0172 79.9091 25.0172 80.3163 25.325C80.024 25.1012 79.4497 24.4018 79.2514 23.8796C79.2096 23.7304 79.1887 23.5905 79.1783 23.4413C79.8674 24.3178 81.35 23.9075 81.35 22.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M89.1499 29.4944C89.1499 27.4131 86.143 26.3389 85.1281 24.4086L85.0905 24.375L85.0717 24.4086C84.0569 26.3389 81.0499 27.4131 81.0499 29.4944C81.0499 31.2401 83.6246 31.9115 84.8838 30.4512C84.9026 30.3841 84.8838 30.9212 84.7898 31.2233C84.4891 32.1129 83.3991 33.4222 82.8729 33.825C83.6058 33.2711 86.5564 33.2711 87.2894 33.825C86.7632 33.4222 85.7295 32.1633 85.3724 31.2233C85.2973 30.9548 85.2597 30.703 85.2409 30.4344C86.4812 32.0122 89.1499 31.2737 89.1499 29.4944Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_dd_3232_25479)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 17,
    width: 18,
    height: 24.6,
    rx: 1.75714,
    fill: "#A046D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0965 24.599C90.7753 24.599 90.4893 24.5341 90.2385 24.4043C89.9899 24.2723 89.7941 24.0919 89.6511 23.8631C89.5103 23.6321 89.4399 23.3692 89.4399 23.0744C89.4399 22.8236 89.496 22.5871 89.6082 22.3649C89.7226 22.1427 89.8865 21.9612 90.0999 21.8204L90.0801 22.0976C89.9195 21.9414 89.793 21.7764 89.7006 21.6026C89.6104 21.4288 89.5653 21.233 89.5653 21.0152C89.5653 20.7402 89.6302 20.5004 89.76 20.2958C89.892 20.0912 90.0724 19.9328 90.3012 19.8206C90.5322 19.7062 90.7973 19.649 91.0965 19.649C91.3957 19.649 91.6597 19.7062 91.8885 19.8206C92.1195 19.9328 92.2999 20.0912 92.4297 20.2958C92.5617 20.5004 92.6277 20.7402 92.6277 21.0152C92.6277 21.233 92.5848 21.4288 92.499 21.6026C92.4132 21.7742 92.2823 21.9414 92.1063 22.1042V21.827C92.3153 21.959 92.4759 22.1372 92.5881 22.3616C92.7025 22.586 92.7597 22.8236 92.7597 23.0744C92.7597 23.3692 92.6882 23.6321 92.5452 23.8631C92.4022 24.0919 92.2053 24.2723 91.9545 24.4043C91.7037 24.5341 91.4177 24.599 91.0965 24.599ZM91.0965 23.7542C91.3077 23.7542 91.4793 23.697 91.6113 23.5826C91.7433 23.4682 91.8093 23.2988 91.8093 23.0744C91.8093 22.8522 91.7433 22.6828 91.6113 22.5662C91.4793 22.4474 91.3077 22.388 91.0965 22.388C90.8853 22.388 90.7148 22.4474 90.585 22.5662C90.4552 22.6828 90.3903 22.8522 90.3903 23.0744C90.3903 23.2988 90.4552 23.4682 90.585 23.5826C90.7148 23.697 90.8853 23.7542 91.0965 23.7542ZM91.0965 21.5366C91.2681 21.5366 91.4078 21.4948 91.5156 21.4112C91.6234 21.3254 91.6773 21.1934 91.6773 21.0152C91.6773 20.837 91.6234 20.705 91.5156 20.6192C91.4078 20.5312 91.2681 20.4872 91.0965 20.4872C90.9249 20.4872 90.7852 20.5312 90.6774 20.6192C90.5696 20.705 90.5157 20.837 90.5157 21.0152C90.5157 21.1934 90.5696 21.3254 90.6774 21.4112C90.7852 21.4948 90.9249 21.5366 91.0965 21.5366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6_3232_25479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.35 28.9191C93.35 27.7628 91.6794 27.166 91.1156 26.0936L91.0948 26.075L91.0843 26.0936C90.5205 27.166 88.85 27.7628 88.85 28.9191C88.85 29.8889 90.2804 30.2619 90.9799 29.4506C90.9903 29.4133 90.9799 29.7117 90.9277 29.8796C90.7606 30.3738 90.1551 31.1012 89.8627 31.325C90.2699 31.0172 91.9091 31.0172 92.3163 31.325C92.024 31.1012 91.4497 30.4018 91.2514 29.8796C91.2096 29.7304 91.1887 29.5905 91.1783 29.4413C91.8674 30.3178 93.35 29.9075 93.35 28.9191Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M101.15 35.4944C101.15 33.4131 98.143 32.3389 97.1281 30.4086L97.0905 30.375L97.0717 30.4086C96.0569 32.3389 93.0499 33.4131 93.0499 35.4944C93.0499 37.2401 95.6246 37.9115 96.8838 36.4512C96.9026 36.3841 96.8838 36.9212 96.7898 37.2233C96.4891 38.1129 95.3991 39.4222 94.8729 39.825C95.6058 39.2711 98.5564 39.2711 99.2894 39.825C98.7632 39.4222 97.7295 38.1633 97.3724 37.2233C97.2973 36.9548 97.2597 36.703 97.2409 36.4344C98.4812 38.0122 101.15 37.2737 101.15 35.4944Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3232_25479",
    x: 0,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_3232_25479",
    x: 12,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_3232_25479",
    x: 24,
    y: 1,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_3232_25479",
    x: 36,
    y: 1,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_dd_3232_25479",
    x: 48,
    y: 1,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_dd_3232_25479",
    x: 60,
    y: 1,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_dd_3232_25479",
    x: 72,
    y: 7,
    width: 46,
    height: 52.6001,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.282353 0 0 0 0 0.827451 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3232_25479",
    result: "effect2_dropShadow_3232_25479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3232_25479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(16.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(28.1 25.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(40.1 19.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(52.1 19.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(64.1 19.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(76.1 19.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6_3232_25479"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6,
    fill: "white",
    transform: "translate(88.1 25.7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudActive);
export default __webpack_public_path__ + "static/media/stud-active.17d073680d62f89357efcaf4f5ab5201.svg";
export { ForwardRef as ReactComponent };